import { createNativeInstance } from '@transifex/native';
import de_DE from '../../__translations__/de_DE.json';
import en_GB from '../../__translations__/en_GB.json';
import en_IE from '../../__translations__/en_IE.json';
import en_US from '../../__translations__/en_US.json';
import es_ES from '../../__translations__/es_ES.json';
import fi_FI from '../../__translations__/fi_FI.json';
import fr_FR from '../../__translations__/fr_FR.json';
import nl_NL from '../../__translations__/nl_NL.json';
import pl_PL from '../../__translations__/pl_PL.json';
import en from '../../__translations__/en.json';
const translationsCache = {
    de_DE,
    en_GB,
    en_IE,
    en_US,
    es_ES,
    fi_FI,
    fr_FR,
    nl_NL,
    pl_PL,
    en,
};
export const getFallbackMessage = (sourceString, localeCode, params) => {
    var _a, _b;
    const tx = createNativeInstance();
    const t = tx.translate.bind(tx);
    const translations = translationsCache[localeCode];
    const message = ((_a = translations === null || translations === void 0 ? void 0 : translations[sourceString]) === null || _a === void 0 ? void 0 : _a.string) ||
        ((_b = translationsCache['en'][sourceString]) === null || _b === void 0 ? void 0 : _b.string) ||
        sourceString;
    return t(message, params);
};
//# sourceMappingURL=index.js.map